import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../../shared/colors";

export const useContactBoxStyles = makeStyles(() => ({
    root: {
        textAlign: "left",
        margin: "auto 1em 1em 1em",
        background: "white",
        borderRadius: "0.5em"
    },
    divWrapper: {
        padding: '24px',
        display: 'inline-block',
        marginBottom: '5px'
    },
    contactIcon: {
        height: "auto",
        width: "28px",
        float: "left",
        marginRight: "16px"
    },
    contactText: {
        color: colors.font.light
    }
}));
